export const BRAND_NAME = 'FairWins77';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'fairwins77.com';
export const PROVIDER_ID = 'BetFair';
